/**
 * enginePreProcessJson_Merge_JsonKey.ts - JSON key processing for EnginePreProcessJson
 * Pure ES module - works in both Node.js and browser via bundler
 */

import { JsonObject } from '../../../../Assembler/dist/app/json/jsonValue.js';
import {
    hasKey,
    getValue,
    convertToString
} from './enginePreProcessJson_Helper.js';
import {
    TYPE_JSONKEY,
    TYPE_JSONKEY_SKIP
} from './enginePreProcessJson_Merge_Constants.js';
import { TemplateOperation, TemplateInfoNode } from './enginePreProcessJson_Helper.js';
import { TemplateOperationKind } from './enginePreProcessJson_Helper.js';
import type { EnginePreProcessJson } from './enginePreProcessJson.js';

/**
 * Processes a JSON key entry
 */
export function processJsonKey(
    this: EnginePreProcessJson,
    loader: { readonly defaultSkipJson: string },
    keyType: string,
    keyNameFromKey: string,
    value: unknown,
    dataJson: JsonObject | null,
    contextJson: JsonObject | null,
    currentTemplate: TemplateInfoNode,
    templateKey: string,
    operations: TemplateOperation[] | null
): string {
    if (keyType === TYPE_JSONKEY) {
        const jsonKeyValue = value;
        const keyName = keyNameFromKey;

        if (typeof jsonKeyValue !== 'string' || !jsonKeyValue.startsWith('{{$')) {
            return convertToString(jsonKeyValue);
        }

        if (contextJson && hasKey(contextJson, keyName)) {
            return convertToString(getValue(contextJson, keyName));
        } else if (dataJson && hasKey(dataJson, keyName)) {
            return convertToString(getValue(dataJson, keyName));
        } else {
            return jsonKeyValue;
        }
    }

    if (keyType === TYPE_JSONKEY_SKIP) {
        // Skip-marked JSON key {{!$KeyName}} - emit defaultSkipJson and log KeySkip op
        if (operations) {
            operations.push(new TemplateOperation({
                templateName: templateKey,
                kind: TemplateOperationKind.KeySkip,
                target: `{{!$${keyNameFromKey}}}`,
                replacedWith: `${currentTemplate.templateName}_${keyNameFromKey}`,
                operations: []
            }));
        }
        return loader.defaultSkipJson;
    }

    return '';
}
